<template>
  <div class="stat-grid">
    <div v-for="item in items" :key="item.label" class="stat-card">
      <strong>{{ format(item.value) }}</strong>
      <span>{{ item.label }}</span>
      <small v-if="item.note">{{ item.note }}</small>
    </div>
  </div>
</template>

<script>
export default {
  name: 'StatGrid',
  props: { task: { type: Object, required: true } },
  computed: {
    items () {
      return [
        { label: '总数据行', value: this.task.totalRows },
        { label: '非法 ISBN', value: this.task.invalidRows, note: '不收费' },
        { label: '重复行', value: this.task.duplicateRows, note: '不重复收费' },
        { label: '有效唯一 ISBN', value: this.task.uniqueIsbnCount },
        { label: '成功匹配唯一 ISBN', value: this.task.matchedUniqueCount, note: '计费数量' },
        { label: '实际填充行', value: this.task.matchedRowCount },
        { label: '未匹配唯一 ISBN', value: this.task.unmatchedUniqueCount, note: '不收费' }
      ]
    }
  },
  methods: {
    format (value) { return (Number(value) || 0).toLocaleString('zh-CN') }
  }
}
</script>

<style lang="less" scoped>
.stat-grid { display: grid; grid-template-columns: repeat(4, 1fr); gap: 12px; }
.stat-card { min-height: 92px; padding: 16px; border: 1px solid #e8edf3; border-radius: 12px; background: #fff; display: flex; flex-direction: column; }
.stat-card strong { font-size: 24px; color: #1f2937; }
.stat-card span { margin-top: 6px; color: #606b7a; }
.stat-card small { margin-top: 3px; color: #16a085; }
@media screen and (max-width: 768px) {
  .stat-grid { grid-template-columns: repeat(2, 1fr); }
  .stat-card { min-height: 84px; padding: 13px; }
  .stat-card strong { font-size: 21px; }
}
</style>
